document.getElementById('postcodeSESub')
  .addEventListener('keyup', function(event) {
    if (event.which === 13) {
      event.preventDefault();
      submitPostcode(document.getElementById('postcodeSESub').value);
    }
  });


function parseData(url,postcode,callBack) {
   var csvData = Papa.parse(url, {
        download: true,
        header:true,
        dynamicTyping: true,
        complete:function(results) {
            callBack(postcode, results.data);
        }
    }); 
}
function submitPostcode(postcode)
{
  	
	var url ="https://cdn.shopify.com/s/files/1/0376/5213/files/rate-shipping-update.csv?v=1614492131";
	parseData(url,postcode, getRate);
}

function getRate(postcode,csvData) {
var message, messageR;
  message = document.getElementById("message");
  messageR = document.getElementById("messageR");
  if ((postcode>=3000)&&(postcode<4000))
  {
  
try {
	var resultRate=csvData.filter(csvData => csvData.Postcode == postcode)[0].Rates
 	var resultDates=csvData.filter(csvData => csvData.Postcode == postcode)[0].Dates
      var resultPromotion=csvData.filter(csvData => csvData.Postcode == postcode)[0].Promotion
    if(resultRate === undefined) throw "is Empty"
    else
    {
      message.innerHTML = "Yes, we deliver to "+postcode+" "+resultDates;
      messageR.innerHTML = "Delivery fee is: $"+resultRate + "</br>" +resultPromotion;
      message.style.backgroundColor = "#c0fecd";
      messageR.style.backgroundColor = "#c0fecd";
    }
  }
  catch(err) {
    message.innerHTML = "We are currently not delivering to "+postcode+". If you would like to enquire about delivery to your location, please contact us at grocer@oasisonline.com.au";
    messageR.innerHTML = "";
    message.style.backgroundColor = "#fcc8c8";
    messageR.style.backgroundColor = "#ffffff";
  }
  
  }else if (((postcode>=0800)&&(postcode<3000))||((postcode>=4000)&&(postcode<=9999))){
  
  	message.innerHTML = "We can ship to you via Australia Post with dry goods only from $8.95";
    messageR.innerHTML = "";
    message.style.backgroundColor = "#c0fecd";
    messageR.style.backgroundColor = "#ffffff";
  }else
  	{
    	message.innerHTML = "Please put the correct postcode";
      messageR.innerHTML = "";
      message.style.backgroundColor = "#fcc8c8";
      messageR.style.backgroundColor = "#ffffff";
    }
      
  
}